import dynamic from "next/dynamic";

import { useGetAdConfig } from "_common/hooks/global";
import { useGetDarkMode } from "_common/hooks/global";
import useDfpSlot         from "_components/features/ads/useDfpSlot";

const Advertisement = dynamic ( () => import ( "_components/features/ads/aboveVideoComments" ) );

const component = () => {
	const { VIDEO_PLAYER_BILLBOARD: config } = useGetAdConfig ();
	const darkMode                           = useGetDarkMode ();

	if ( !config?.enabled )
		return null;

	if ( config?.adManager === "vmax" )
		return (
			<Advertisement id = { config?.adUnitId } />
		);

	const path = darkMode ? config?.slotId?.dark : config?.slotId?.light;

	return (
		<div style = { { marginBlockStart: "2rem", marginInline: "auto" } }>

			<AdSlot
				path = { path }
				size = { config?.size }
			/>
		</div>
	);
};

const AdSlot = ( { path, size } ) => {
	const comp = useDfpSlot ( {
		id: "gpt-passback-above-comments",
		path,
		size
	} );

	return comp;
};

export default component;
